<!--SKU编辑  -->
<template>
	<el-dialog title="账户充值"
		:visible.sync="dialogVisible"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		width="400px">
		<div class="form-box">
			<el-form :model="dataForm" :rules="rules" ref="dataForm" label-width="90px" size="small">
				<div class="ml20">
					账户：{{accountName}}
				</div>
				<el-form-item class="mt20" label="充值金额:" prop="charge">
					<el-input size="small" v-model="dataForm.charge" maxlength="11"></el-input>
				</el-form-item>
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button size="small" @click="dialogVisible = false">取 消</el-button>
			<el-button size="small" type="primary" @click="handleSubmit">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	import { debounce } from '@/utils/debounce'
	export default {
		components: {

		},
		data() {
			return {
				dialogVisible: false,
				accountName: '',
				dataForm: {
					accountId: '',
					charge: ''
				},
				rules: {
					charge: [
						{
							required: true,
							message: '请输入充值金额',
							trigger: 'blur'
						},
						{
							// pattern: /^[0-9]*$/, //请输入大于0的整数
							// pattern: /^([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])$/, //大于0的数字包含小数
							// pattern: /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1,2}$)/ , //请输入大于0的整数或者保留两位小数
							pattern: /^([\\+ \\-]?(([1-9]\d{0,10})|([0-9]\d*.\d?[1-9]{1})))([.]\d{0,2})?$/,
							message: '请输入正确格式金额(最多保留两位小数)'
						},
					],
				}
			}
		},
		created() {

		},
		methods: {
			init(dt) {
				this.dialogVisible = true;
				this.$nextTick(() => {
					this.$refs.dataForm.resetFields();
					if(dt) {
						this.accountName = dt.accountName;
						this.dataForm.accountId = dt.accountId;
					}
				})
			},
			handleSubmit:debounce(function() {
				if(Number(this.dataForm.charge) == 0) {
					this.$message.error('充值金额不能为0');
					return
				}
				if(this.dialogVisible == false) {
					return
				}
				this.$refs['dataForm'].validate(valid => {
					if (valid) {
						this.$confirm('是否确认保存？', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
						}).then(() => {
							let that = this;
							that.$request.post(
								'prepaidAccountCharge',
								true, that.dataForm
							)
							.then((res) => {
								that.dialogVisible = false;
								if (res) {
									that.$emit('getList');
									that.$message.success('保存成功');
								}
							})
						}).catch(() => {});
					} else {
						return false;
					}
				});
			},1000,true),
		},
		beforeDestroy() {

		}
	}

</script>
<style lang='scss' scoped>
	.mb0 {
		margin-bottom: 0 !important;
	}

</style>
